import React from "react";
import { Alert, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import { useGetIncomingOwnershipTransferQuery } from "../../../api/ducApiSlice";
import { colours } from "../../../StyleConstants";

// Shown to a user who has been named the new Lead Investigator on someone else's group DUC
// (LC-221). This is the only in-app way to discover and act on a pending transfer - the invite
// email is best-effort (e.g. not deliverable without a configured SMTP server locally).
const IncomingOwnershipTransferBanner: React.FC = () => {
    const { data: incomingTransfer } = useGetIncomingOwnershipTransferQuery({});
    const navigate = useNavigate();

    if (!incomingTransfer?.transferId || incomingTransfer?.newDucDetailsId) {
        // No incoming transfer, or one already accepted (a new DUC row exists) - nothing to show.
        return null;
    }

    const handleClick = () => {
        localStorage.setItem('status', 'NotSubmitted')
        localStorage.setItem('edit', 'false')
        localStorage.setItem('formType', 'GENERAL')
        localStorage.setItem('AddSub', 'false')
        localStorage.setItem('isGroup', 'true')
        localStorage.removeItem('skipPrevData')
        localStorage.setItem('ownershipTransferId', String(incomingTransfer.transferId))
        navigate("/duc/request")
    }

    return (
        <Alert
            role="alert"
            icon={<SwapHorizRoundedIcon fontSize="inherit" sx={{ color: colours.core.white }} />}
            sx={{
                backgroundColor: colours.midnightBlue.blue,
                color: colours.core.white,
                borderRadius: 1,
                alignItems: "center",
                "& .MuiAlert-message": { flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 },
            }}
        >
            <Typography fontWeight="500" sx={{ color: colours.core.white }}>
                You have been designated as the new Lead Investigator on a Data Use Certification by {incomingTransfer.originalPiName || "a colleague"}. Please complete your application to accept this role.
            </Typography>
            <Button
                variant="primary"
                onClick={handleClick}
                sx={{ minWidth: "max-content", whiteSpace: "nowrap" }}
            >
                Begin My Application
            </Button>
        </Alert>
    );
};

export default IncomingOwnershipTransferBanner;
